import { render } from "./TarefasCliente.vue?vue&type=template&id=6f86f285&scoped=true"
import script from "./TarefasCliente.vue?vue&type=script&lang=js"
export * from "./TarefasCliente.vue?vue&type=script&lang=js"

import "./TarefasCliente.vue?vue&type=style&index=0&id=6f86f285&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f86f285"],['__file',"src/views/TarefasCliente/TarefasCliente.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f86f285"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f86f285', __exports__)) {
    console.log('reload')
    api.reload('6f86f285', __exports__)
  }
  
  module.hot.accept("./TarefasCliente.vue?vue&type=template&id=6f86f285&scoped=true", () => {
    console.log('re-render')
    api.rerender('6f86f285', render)
  })

}


export default __exports__